import React, { useState } from 'react';
import InputField from '../../input-field';
import Button from '../../button';

const AccountForgotPasswordForm: React.FC = () => {
  const [username, setUsername] = useState('');
  const [message, setMessage] = useState('');

  const handleClick = async (e) => {
    e.preventDefault();

    if (!username) {
      setMessage('All fields are required.');
      return;
    }

    const bodyData = new URLSearchParams();
    bodyData.append('username', username);

    const res = await fetch('/api/forgot-password', {
      method: 'post',
      body: bodyData.toString(),
    });

    if (res.ok) {
      setMessage('Sent email on file to change password.');
    } else {
      setMessage('An unknown error occurred, please try again.');
    }
  };

  return (
    <div className="content">
      <form>
        <h2>Forgot Password</h2>
        <InputField
          id="username"
          label="Username"
          type="text"
          onChange={(e) => setUsername(e.target.value)}
        />
        <Button text="Submit" onClick={handleClick} />
        {message && <p>{message}</p>}
      </form>
      {/* language=CSS */}
      <style jsx>{`
        h2 {
          margin: 0 0 1rem;
          font-family: 'Volvo Novum', sans-serif;
          font-weight: 400;
        }
      `}</style>
    </div>
  );
};

export default AccountForgotPasswordForm;
